"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _localizeDebugHelper = _interopRequireDefault(require("../helpers/localize-debug-helper"));

var _translatingLocalizationContainer = _interopRequireDefault(require("./translating-localization-container"));

var _runtimeLocalizationContainer = _interopRequireDefault(require("./runtime-localization-container"));

var LocalContainer = function LocalContainer(props) {
  var localizing = (0, _localizeDebugHelper["default"])();
  return localizing ? /*#__PURE__*/_react["default"].createElement(_translatingLocalizationContainer["default"], props) : /*#__PURE__*/_react["default"].createElement(_runtimeLocalizationContainer["default"], props);
};

var _default = LocalContainer;
exports["default"] = _default;